import { type YatPageItem } from '@app/client/common/structs/yatPage/yat-page-items';

interface MetaAddition {
    description: string | null;
    image: string | null;
}

export function processPageMeta(item: YatPageItem) {
    const meta: MetaAddition = {
        description: null,
        image: null,
    };

    // TODO: `meta` does not exist on this type!
    if (item.item_type.Link?.['meta']) {
        item.item_type.Link['meta'].map((metaItem) => {
            if (metaItem.property) {
                switch (metaItem.property.toLowerCase()) {
                    case 'og:image':
                        meta.image = metaItem.content;
                        break;
                    case 'description':
                        meta.description = metaItem.content;
                        break;
                }
            }
        });
    }

    return meta;
}
